import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/financial-snapshot/new/loading';

export const Route = createFileRoute('/_private/financial-snapshots/new')({
  component: Loading,
});
